import { render, staticRenderFns } from "./CardDepositAndWithdraw.vue?vue&type=template&id=98ec6fc0&"
import script from "./CardDepositAndWithdraw.vue?vue&type=script&lang=js&"
export * from "./CardDepositAndWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports